import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  NavItem,
  Nav,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  TabContent,
  TabPane,
  Badge,
  CardBody,
  Card,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import {
  API_Documents,
  API_Documents_Upload,
  API_Logs,
  gAPI_Property_List_By_Group,
  gAPI_Users_By_Id,
} from '../../../../../constants/APIs';
import DocumentUpload from './DocumentUpload';
import moment from 'moment';
import { NotificationManager } from '../../../../../components/common/react-notifications';
function generateRandomColor() {
  var arr = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  return arr[Math.floor(Math.random() * arr.length)];
}

function DocumentForm({
  documentDetails,
  submit,
  visible,
  propertyId,
  label,
  taglist,
  toggle,
  folders,
  selectedFolder
}) {
  const [property, setProperty] = useState([
    { label: 'All', value: 'All', key: 'All' },
  ]);
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [addTagModel, setAddTagModel] = useState(false);
  const [tags, setTags] = useState([]);
  const [ownTag, setOwnTag] = useState('');
  const [activeTab, setActiveTab] = useState('details');
  const [selectedTags, setSelectedTags] = useState([]);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [logList, setLogList] = useState([]);
  const [isvisible, setIsVisible] = useState(false);

  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState(false);
  const [isAgree, setAgree] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [fileErrorMsg, setFileErrorMsg] = useState('');
  const [errMsg, setErrorMsg] = useState('');
  const [folder, setFolder] = useState(
    documentDetails?.documentPath || selectedFolder || 'root'
  );
  const handleFileToggle = () => {
    setFileError(!fileError);
  };
  let fileObj = [];
  const [documentData, setDocumentData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    title: '',
    link: '',
    tags: [],
    properties: [],
    internalCopilot: false,
    status: 'Draft',
    creator: 'Admin',
    path: documentDetails?.documentPath || selectedFolder || 'root',
    sourceUrl: ''
  });
  const handleDocumentBusiness = (options) => {
    setSelectedProperty(options);
    if (options.filter((f) => f.value === 'All').length === 0) {
      setDocumentData({
        ...documentData,
        properties: options.map((i) => i.value),
      });
    } else {
      setDocumentData({
        ...documentData,
        setDocumentData: property
          .filter((f) => f.id !== 'All')
          .map((i) => i.id),
      });
    }
  };
  useEffect(() => {
    if (!documentDetails) {
      setDocumentData(prev => ({
        ...prev,
        path: selectedFolder
      }));
      setFolder(selectedFolder);
    }
  }, [selectedFolder]);
  const handleSave = () => {
    if (documentDetails !== undefined && files.length === 0) {
      submit(documentData);
    } else {
      if (isAgree && isCheck) {
        const data = new FormData();
        if (files !== undefined && files.length > 0) {
          files.forEach((file) => {
            data.append('files', file.img);
            data.append('tags', file.tags);
            data.append('captions', file.caption);
          });
          data.append('propertyId', propertyId);
          data.append('groupId', getGroupID());
          data.append('creator', 'dashboard');

          // setApiState("processing")
          AxiosAPI({
            method: 'post',
            url: `${API_Documents_Upload}`,
            data: data,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(
            (res) => {
              if (res.data?.status !== undefined) {
                const updatedDocument = {
                  ...documentData,
                  link: res.data?.status,
                };

                if (updatedDocument.link) {
                  submit(updatedDocument);
                } else {
                  setFileErrorMsg('Please upload .txt or .docx document.');
                  handleFileToggle();
                }
              }
            },
            (error) => {
              console.log('eee.data', error.data);
            }
          );
        } else {
          setFileErrorMsg('Please upload .txt or .docx document.');
          handleFileToggle();
        }
      } else {
        handleToggle();
        setErrorMsg('Please check the checkbox.');
      }
    }
  };
  const handleToggle = () => {
    setIsVisible(!isvisible);
  };
  useEffect(() => {
    let documentProperties = [];
    if (documentDetails !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_Logs}/${documentDetails.id}?type='Document`,
      }).then((res) => {
        setLogList(res.data);
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        documentProperties = documentDetails?.properties
          ? documentDetails?.properties
          : [];
        documentDetails.userName = res.data.fullName;
        let options = [];
        let selectedOptions = [];
        options.push({
          label: 'Add new tag',
          value: 'Add new tag',
          key: 'Add new tag',
        });
        if (taglist !== undefined && taglist.length > 0) {
          taglist.map((m) => {
            if (options.filter((o) => m == o.value).length === 0)
              options.push({
                label: m,
                value: m,
                key: m,
              });
          });
        }
        if (
          documentDetails.tags !== undefined &&
          documentDetails.tags.length > 0
        ) {
          documentDetails.tags.map((m) => {
            if (options.filter((o) => m == o.value).length === 0) {
              options.push({
                label: m,
                value: m,
                key: m,
              });
            }
            selectedOptions.push({
              label: m,
              value: m,
              key: m,
            });
          });
        }

        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
          .then((json) => {
            if (json.data !== undefined && json.data.length > 0) {
              let lst = [{ id: 'All', name: 'All' }];
              json.data.map((m) => lst.push({ id: m.id, name: m.name }));
              setProperty(lst);
              if (
                documentProperties !== undefined &&
                documentProperties.length > 0
              ) {
                let selectedList = [];
                if (documentProperties.length === json.data.length)
                  setSelectedProperty({
                    label: 'All',
                    value: 'All',
                    key: 'All',
                  });
                else {
                  documentProperties.map((m) => {
                    if (json.data.filter((f) => f.id === m).length > 0)
                      selectedList.push({
                        key: json.data.filter((f) => f.id === m)[0].id,
                        label: json.data.filter((f) => f.id === m)[0].name,
                        value: json.data.filter((f) => f.id === m)[0].id,
                      });
                  });
                  setSelectedProperty(selectedList);
                }
              }
            }
          })
          .catch((err) => console.error(err));
        console.log(265, documentDetails);
        setSelectedTags(selectedOptions);
        setTags(options);
        setDocumentData({
          ...documentDetails,
          sourceUrl: documentDetails.documentSourceUrl || '',
        });
      });
    } else {
      let options = [];
      options.push({
        label: 'Add new tag',
        value: 'Add new tag',
        key: 'Add new tag',
      });
      if (taglist !== undefined && taglist.length > 0) {
        taglist.map((m) => {
          if (options.filter((o) => m == o.value).length === 0)
            options.push({
              label: m,
              value: m,
              key: m,
            });
        });
      }
      setTags(options);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        setDocumentData({ ...documentData, userName: res.data.fullName });
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((json) => {
          if (json.data !== undefined && json.data.length > 0) {
            let lst = [{ id: 'All', name: 'All' }];
            json.data.map((m) => lst.push({ id: m.id, name: m.name }));
            setProperty(lst);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [propertyId]);

  const handleChange = (e) => {
    setDocumentData({ ...documentData, [e.target.name]: e.target.value });
  };

  const handleTags = (selectedTags) => {
    if (
      selectedTags.filter((elem) => elem.value === 'Add new tag').length === 0
    ) {
      setSelectedTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setDocumentData({
        ...documentData,
        tags: tagsArr,
      });
    } else {
      setAddTagModel(!addTagModel);
    }
  };

  const saveUploadLink = (e) => {
    setDocumentData({
      ...documentData,
      link: e.status,
    });
    NotificationManager.success(
      '',
      'Document Sucessfully Uploaded',
      3000,
      null,
      null,
      'success'
    );
  };
  const handleOwntag = (val) => {
    let tag = [...tags];
    tag.push({ label: val, value: val, key: val });
    let tag1 = [...selectedTags];
    tag1.push({ label: val, value: val, key: val });
    setTags(tag);
    setSelectedTags(tag1);
    setAddTagModel(!addTagModel);
    setOwnTag('');
    const tagsArr = tag1.map((elem) => elem.value);
    setDocumentData({
      ...documentData,
      tags: tagsArr,
    });
  };
  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const handleFolderChange = (event) => {
    setFolder(event.target.value);
    setDocumentData({
      ...documentData,
      path: event.target.value,
    });
  };
  const UploadDocument = () => {
    return (
      <Row className="mb-2 text-left">
        <section className="container justify-content-start">
          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} />
            <div class="dz-default dz-message">
              <span>Drop files here to upload, or click to select files. Recommended upload limit of 10mb per file. Supported formats: JPEG, PNG, GIF, WEBP, SVG.</span>
              <p>(.doc, .pdf or .txt files are allowed)</p>
              <p className="font-weight-medium mb-0 ">
                <i className="demo-icon simple-icon-cursor-move"></i>
              </p>
            </div>
          </div>
          <div
            className="filepicker dropzone-gallery dz-clickable dz-started"
            style={{ minHeight: '100px', border: '0px' }}
          >
            {files.map((file, index) => (
              <div
                className="dz-preview dz-file-preview mb-3"
                key={index}
                style={{ height: '100px' }}
              >
                <div className="row">
                  <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div>
                      {' '}
                      <span data-dz-name>{file.img.name}</span>{' '}
                    </div>
                    <div className="text-primary text-extra-small" data-dz-size>
                      {file.img.size}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Row>
    );
  };
  const handleChecked = (e) => {
    setDocumentData({ ...documentData, internalCopilot: e.target.checked });
  };
  const toggleUpload = () => {
    setUploadDocument(!uploadDocument);
  };
  const selectedImage = (image) => { };
  const { getRootProps, getInputProps } = useDropzone({
    //accept: 'image/*',
    // accept: 'image/*,font/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (
          file.name.includes('txt') ||
          file.name.includes('docx') ||
          file.name.includes('pdf') ||
          file.name.includes('xlsx') ||
          file.name.includes('ppt') ||
          file.name.includes('pptx')
        ) {
          fileObj = [
            {
              img: Object.assign(file, {
                preview: URL.createObjectURL(file),
              }),
              tags: [],
              caption: '',
            },
          ];
        } else {
          handleFileToggle();
          setFileErrorMsg(
            'Invalid document, please upload .txt or .docx document.'
          );
        }
      });
      setFiles(fileObj);
    },
  });
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>{label}</ModalHeader>
        <ModalBody>
          {documentDetails !== undefined && documentDetails.id !== undefined ? (
            <Fragment>
              <Nav tabs className="card-header-tabs ml-0 mr-0">
                <NavItem className="w-10 text-center mb-3">
                  <NavLink
                    className={classnames({
                      active: activeTab === 'details',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      toggleAppMenu('details');
                    }}
                    to="#"
                  >
                    Details
                  </NavLink>
                </NavItem>
                <NavItem className="w-10 text-center mb-3">
                  <NavLink
                    className={classnames({
                      active: activeTab === 'Revision',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      toggleAppMenu('Revision');
                    }}
                    to="#"
                  >
                    Revision
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="">
                <TabPane tabId="details" className="chat-app-tab-pane">
                  {label === 'View Document' && documentData?.creator === 'WebPage' ?
                    (
                      <Fragment>
                        <Row>
                          <Colxx sm={6} className="mb-3">
                            <Label>
                              Document Title
                            </Label>
                            <Input
                              value={documentData.title}
                              name="title"
                              disabled='true'
                              onChange={handleChange}
                            ></Input>
                          </Colxx>
                          <Colxx sm={6} className="mb-3">
                            <Label>
                              Status
                            </Label>
                            <Input
                              type="text"
                              value={documentData.status}
                              name="status"
                              onChange={handleChange}
                              disabled='true'
                            >
                            </Input>
                          </Colxx>

                        </Row>
                        <Row>
                          <Colxx sm={6} className="mb-3">
                            <Label>
                              Creator
                            </Label>
                            <Input
                              type="title"
                              value={documentData.creator}
                              name="creator"

                              disabled='true'
                            >
                            </Input>
                          </Colxx>
                          <Colxx sm={4} className="mb-3">
                            <Label>Internal Copilot Only</Label>
                            <CustomInput
                              type="checkbox"
                              min={0}
                              name="internalCopilot"
                              checked={documentData.internalCopilot ? true : false}
                              onChange={handleChecked}
                              disabled='true'
                            />
                          </Colxx>
                        </Row>
                      </Fragment>
                    )
                    :
                    (
                      <Fragment>
                        <Row>
                          <Colxx sm={6} className="mb-3">
                            <Label>
                              Document Title<span style={{ color: 'red' }}> *</span>
                            </Label>
                            <Input
                              value={documentData.title}
                              name="title"
                              disabled={
                                documentData?.creator === 'WebPage' ? true : false
                              }
                              onChange={handleChange}
                            ></Input>
                          </Colxx>
                          <Colxx sm={6} className="mb-3">
                            <Label>
                              Status<span style={{ color: 'red' }}> *</span>
                            </Label>
                            <Input
                              type="select"
                              value={documentData.status}
                              name="status"
                              onChange={handleChange}
                            >
                              <option value="Draft">Draft</option>
                              <option value="ReadyToPublish">Ready to publish</option>
                              {/* <option value="Published">Published</option> */}
                            </Input>
                          </Colxx>
                        </Row>
                        <Row>
                          <Colxx sm={6} className="mb-3">
                            <FormGroup>
                              <Label for="bookingUrl">Tags</Label>
                              <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                value={selectedTags}
                                onChange={handleTags}
                                options={tags}
                              />
                            </FormGroup>
                          </Colxx>
                          <Colxx sm={4} className="mb-3">
                            <Label>Internal Copilot Only</Label>
                            <CustomInput
                              type="checkbox"
                              min={0}
                              name="internalCopilot"
                              checked={documentData.internalCopilot ? true : false}
                              onChange={handleChecked}
                            />
                          </Colxx>
                          <Colxx sm={6} className="mb-3">
                            <Label>Other Applicable Businesses</Label>
                            <Select
                              components={{ Input: CustomSelectInput }}
                              className="react-select"
                              classNamePrefix="react-select"
                              isMulti={true}
                              name="form-field-name"
                              options={
                                property.length > 0 &&
                                property
                                  .filter((f) => f.id !== propertyId)
                                  .map((x, i) => {
                                    return { label: x.name, value: x.id, key: i };
                                  })
                              }
                              value={selectedProperty}
                              onChange={(val) => handleDocumentBusiness(val)}
                            />
                          </Colxx>
                        </Row>
                        <Row className="mb-2 ">
                          <Colxx xxs="6">
                            <Label>Document Source Url</Label>
                            <Input
                              value={documentData.sourceUrl}
                              name="sourceUrl"
                              onChange={handleChange}
                            />
                          </Colxx>
                          <Colxx xxs="6">
                            <Label>Move to Folder :</Label>{' '}
                            <Input className='input_sty'
                              type="select"
                              name="folder"
                              // placeHolder="Folder"
                              value={folder}
                              placeholder=" Please select to Move to Folder"
                              onChange={(event) => handleFolderChange(event)}
                            >
                              <option value={''}>Please select to Move to Folder </option>
                              {folders?.map((m) => (
                                <option value={m?.folderPath + '/' + m?.folderName}>
                                  {m?.folderName}
                                </option>
                              ))}
                            </Input>
                          </Colxx>
                        </Row>
                      </Fragment>
                    )}
                  {/* {(documentData.link !== undefined && documentData.link !== '') && <Row>
                                        <Colxx sm={10} className="mb-3">
                                            <Label for="bookingUrl">Document Link</Label>
                                            <Input
                                                value={documentData.link}
                                                name="title"
                                                disabled={true}
                                            >
                                            </Input>
                                        </Colxx>
                                        <Colxx sm={2} className="mb-3">
                                            <Label for="bookingUrl"></Label>
                                            <Button
                                                style={{ marginTop: '2rem' }}
                                                color="primary"
                                                size="xs"
                                                outline
                                                onClick={() => handleDownload(documentData)}
                                            >
                                                Download
                                            </Button>
                                        </Colxx>
                                    </Row>} */}
                  {/* <Row>
                                        <Colxx md={12}>
                                            <Button
                                                color="success"
                                                size="xs"
                                                className="mt-1"
                                                onClick={() => toggleUpload()}
                                            >
                                                Upload New Version
                                            </Button>
                                        </Colxx>
                                    </Row> */}
                </TabPane>
                <TabPane tabId="Revision" className="chat-app-tab-pane">
                  {logList !== undefined &&
                    logList.length > 0 &&
                    logList.map((m, index) => (
                      <Row className="mb-3">
                        <Colxx xxs="12" xs="3">
                          <Fragment>
                            Version On:
                            <br />
                            {moment(m.date).format('MMM DD, YYYY h:mm a')}
                            <br />
                            <br />
                            {m.action !== undefined && (
                              <Fragment>
                                Action:
                                <br />
                                <span
                                  style={{
                                    color: `${m.action.includes('Delete')
                                      ? 'red'
                                      : 'green'
                                      }`,
                                  }}
                                >
                                  {m.action}
                                </span>
                              </Fragment>
                            )}
                          </Fragment>
                        </Colxx>
                        <Colxx xxs="12" xs="9">
                          <Card
                            className="d-flex mb-3"
                            key={`faqItem_${index}`}
                            style={{ borderRadius: '25px' }}
                          >
                            <CardBody
                              className="logsBody"
                              style={{ overflowX: 'scroll' }}
                            >
                              <Row className="mb-2">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Title: </b>
                                  {m.content.Title}
                                </Colxx>
                              </Row>
                              <Row className="mb-2">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Status: </b>
                                  {m.content.Status === 'Archieve' ? (
                                    <span color="red">{m.content.Status}</span>
                                  ) : (
                                    <span color="green">
                                      {m.content.Status}
                                    </span>
                                  )}
                                </Colxx>
                              </Row>
                              <Row className="mb-2">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Document Link</b>
                                </Colxx>
                                <Colxx xxs="12" className="ml-0">
                                  {m.content.Link}
                                </Colxx>
                              </Row>
                              <Row className="mb-2">
                                <Colxx xxs="12" className="mb-2">
                                  <b>Tags</b>
                                </Colxx>
                                <Colxx xxs="12" className="ml-0">
                                  {m.content.Tags !== undefined &&
                                    m.content.Tags.length > 0 &&
                                    m.content.Tags.map((m, i) => (
                                      <Badge
                                        color={generateRandomColor(i)}
                                        className="mt-1 mr-1"
                                      >
                                        {m}
                                      </Badge>
                                    ))}
                                </Colxx>
                              </Row>
                              {m.comments !== undefined &&
                                m.comments !== null &&
                                m.comments !== '' && (
                                  <Row className="">
                                    <Colxx xxs="12" className="mb-2">
                                      <b>Comments</b>
                                    </Colxx>
                                    <Colxx xxs="12" className="ml-0">
                                      {m.comments}
                                    </Colxx>
                                  </Row>
                                )}
                            </CardBody>
                          </Card>
                        </Colxx>
                      </Row>
                    ))}
                </TabPane>
              </TabContent>
            </Fragment>
          ) : (
            <Fragment>
              <Row>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Document Title<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    value={documentData.title}
                    name="title"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Status<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={documentData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Draft">Draft</option>
                    <option value="ReadyToPublish">Ready to publish</option>
                  </Input>
                </Colxx>
              </Row>
              <Row>
                <Colxx sm={6} className="mb-3">
                  <FormGroup>
                    <Label for="bookingUrl">Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Internal Copilot Only</Label>
                  <CustomInput
                    type="checkbox"
                    min={0}
                    name="internalCopilot"
                    checked={documentData.internalCopilot ? true : false}
                    onChange={handleChecked}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Other Applicable Businesses</Label>
                  <Select
                    components={{ Input: CustomSelectInput }}
                    className="react-select"
                    classNamePrefix="react-select"
                    isMulti={true}
                    name="form-field-name"
                    options={
                      property.length > 0 &&
                      property
                        .filter((f) => f.id !== propertyId)
                        .map((x, i) => {
                          return { label: x.name, value: x.id, key: i };
                        })
                    }
                    value={selectedProperty}
                    onChange={(val) => handleDocumentBusiness(val)}
                  />
                </Colxx>
              </Row>
              {/* {(documentData.link !== undefined && documentData.link !== '') && <Row>
                                <Colxx sm={10} className="mb-3">
                                    <Label for="bookingUrl">Document Link</Label>
                                    <Input
                                        value={documentData.link}
                                        name="title"
                                        disabled={true}
                                    >
                                    </Input>
                                </Colxx>
                                <Colxx sm={2} className="mb-3">
                                    <Label for="bookingUrl"></Label>
                                    <Button
                                        style={{ marginTop: '2rem' }}
                                        color="primary"
                                        size="xs"
                                        outline
                                        onClick={() => handleDownload(documentData)}
                                    >
                                        Download
                                    </Button>
                                </Colxx>
                            </Row>} */}
              {/* <Row>
                                <Colxx md={12}>
                                    <Button
                                        color="success"
                                        size="xs"
                                        className="mt-1"
                                        onClick={() => toggleUpload()}
                                    >
                                        Upload Document
                                    </Button>
                                </Colxx>
                            </Row> */}
            </Fragment>
          )}
          {documentData?.creator === 'WebPage' ? null : UploadDocument()}
          {documentData?.creator === 'WebPage' ? null : (
            <div
              className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
              style={{ justifyContent: 'start' }}
            >
              <CustomInput
                type="checkbox"
                id="isagreeDocument"
                value={isAgree}
                checked={isAgree}
                onChange={(e) => {
                  setAgree(!isAgree);
                }}
              >
                <span>
                  I have copyright or permissions to use this document.
                </span>
              </CustomInput>
            </div>
          )}
          {documentData?.creator === 'WebPage' ? null : (
            <div
              className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
              style={{ justifyContent: 'start' }}
            >
              <CustomInput
                type="checkbox"
                id="ischeckDocument"
                value={isCheck}
                checked={isCheck}
                onChange={(e) => {
                  setIsCheck(!isCheck);
                }}
              >
                <span>
                  This document does not contain any personally identifiable
                  information.
                </span>
              </CustomInput>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {label !== 'View Document' && <Button color="primary" onClick={handleSave}>
            Save
          </Button>
          }
          <Button color="secondary" onClick={toggle}>
            Back
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={addTagModel}
        toggle={() => {
          setAddTagModel(!addTagModel);
        }}
        style={{ maxWidth: '900px' }}
      >
        <ModalHeader toggle={() => setAddTagModel(!addTagModel)}>
          Add New Tag
        </ModalHeader>
        <ModalBody>
          <div className="margin-0">
            <Label>
              Assign one or more search tags to the document. This helps with
              document identification, search and filtering.
            </Label>
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => {
                setOwnTag(e.target.value);
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleOwntag(ownTag)}>
            Add
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setAddTagModel(!addTagModel);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isvisible} toggle={handleToggle}>
        <ModalHeader toggle={handleToggle}>Error</ModalHeader>
        <ModalBody>
          <h6 className="m-2">{errMsg}</h6>
        </ModalBody>
        <ModalFooter>
          <Button
            className="ml-2"
            color="dark"
            outline
            size="xs"
            onClick={handleToggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={fileError} toggle={handleFileToggle}>
        <ModalHeader toggle={handleFileToggle}>Document</ModalHeader>
        <ModalBody>
          <h6 className="m-2">{fileErrorMsg}</h6>
        </ModalBody>
        <ModalFooter>
          <Button
            className="ml-2"
            color="dark"
            outline
            size="xs"
            onClick={handleFileToggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(DocumentForm));
